import dom from "../../../dist/jsx-render/dom"
import JSXComponent from "../../../dist/jsx-render/JSXComponent"
import { EditTypes } from "./EditTypes";
import { MsoTable } from "./MsoTable";
import { Columns } from "./Columns";
import { TableColumnTypes } from "./TableColumnTypes";
import { app } from "../../Frame/App";
import { AppDragTypes } from "../../Frame/AppDragTypes";
import { FlexTableComponent } from "./FlexTableComponent";
import { ColumnDeleteIcon } from "./ColumnDeleteIcon";
import { FlexTableRowItem } from "./FlexTableRowItem";
import { DynPopup } from "../../Components/DynPopup";
import { PagePopup, PopupCloseType } from "../PagePopup";
import { WidgetController } from "../Widgets/WidgetController";
import { WidgetContextFe } from "../Widgets/Components/EditRow/AvailableWidgets/WidgetContextFe";

export type FlexContentRowComponentProps = {
    columns: Columns;
    rowItem: FlexTableRowItem;
    onRowClick?: (ev: MouseEvent) => void;
    idField: string;
    editType: EditTypes;
    table: MsoTable;
    useLock: boolean;
    fixedLayout: boolean;
    enableDragDrop: boolean;
    flexTable: FlexTableComponent;
    elementId?: string;
    rowClickUrl?: string;
    rowClickAllowedUrl?: string;
}

export class FlexContentRowComponent extends JSXComponent {
    props: FlexContentRowComponentProps;
    childRow: HTMLElement;
    childTable: MsoTable;
    cells: HTMLElement[] = [];
    dragCounter: number = 0;

    public get modelId(): string {
        return this.props.rowItem.modelId;
    }

    constructor(props: FlexContentRowComponentProps) {
        super(props);
    }

    element: HTMLElement;

    private createRowFixed(): HTMLElement {
        return (
            <tr id={this.props.elementId} className="mt-content-row" data-id={this.props.idField ? this.props.rowItem.modelId : ""}>
                {...this.createCells()}
                {this.props.useLock
                    ? <td className="lockInfo lock">
                        <div className="lock-icon fas" />
                    </td>
                    : []}
            </tr>
        )
    }

    private createRowFlex(): HTMLElement {
        return (
            <div id={this.props.elementId} className="mt-content-row" data-id={this.props.idField ? this.props.rowItem.modelId : ""}>
                {...this.createCells()}
                {this.props.useLock
                    ? <td className="lockInfo lock">
                        <div className="lock-icon fas" />
                    </td>
                    : []}
            </div>
        )
    }

    private createCells(): HTMLElement[] {
        let result: HTMLElement[] = [];
        for (let col of this.props.columns.items) {
            let cell = col.createCell(this.props.rowItem.model, this.props.idField);
            if (!this.props.fixedLayout && col.width) {
                cell.style.width = Math.round(col.width / window.devicePixelRatio) + "px";
            }

            //// Edit types and rowClick on individual columns, to take the column property prohibitRowClick into account.
            //if (this.props.editType == EditTypes.None && this.props.onRowClick && !col.prohibitRowClick) {
            //    cell.addEventListener("click", this.props.onRowClick);
            //    cell.classList.add("pointer");
            //} else {
            this.cells.push(cell);
            result.push(cell);
        }

        if (this.props.table.props.showDeleteButton) {
            let cell: HTMLElement;
            let col = new ColumnDeleteIcon(this.props.table, this.props.flexTable.createDeleteColumns(), this.props.table.id);
            col.width = 40;
            cell = col.createCell(this.props.rowItem.model, this.props.idField);
            if (!this.props.fixedLayout) {
                cell.style.width = Math.round(col.width / window.devicePixelRatio) + "px";
            }
            this.cells.push(cell);
            result.push(cell);

        }

        return result;
    }

    render() {
        this.props.elementId = app.createGuid();
        this.props.rowItem.model["_rowElementId"] = this.props.elementId;

        if (this.props.fixedLayout) {
            this.element = this.createRowFixed();
        }
        else {
            this.element = this.createRowFlex();
        }

        // Set background color if colorDataField was set in MsoTable
        if (this.props.table
            && this.props.table.props.colorDataField
            && this.props.rowItem.model[this.props.table.props.colorDataField]) {
            this.element.style.backgroundColor = this.props.rowItem.model[this.props.table.props.colorDataField];
        }

        if (this.props.enableDragDrop) {
            this.element.draggable = true;
            this.element.addEventListener("dragstart", this.onDragStart);
            this.element.addEventListener("dragenter", this.onDragEnter);
            this.element.addEventListener("dragleave", this.onDragLeave);
            this.element.addEventListener("dragover", this.onDragOver);
            this.element.addEventListener("dragend", this.onDragEnd);
            this.element.addEventListener("drop", this.onDrop);
        }

        if (this.props.editType == EditTypes.None || this.props.editType == undefined || this.props.rowClickUrl) {
            if (this.props.rowClickUrl) {
                this.props.editType = EditTypes.None;
                this.element.classList.add("pointer");
                this.element.addEventListener("click", () => {
                    if (this.props.rowClickAllowedUrl) {
                        $.ajax({
                            url: app.resolveUrl(this.props.rowClickAllowedUrl + "/" + this.props.rowItem.modelId),
                            method: "GET",
                            success: (response) => {

                                if (response == true) {
                                    this.redirectToRowClickUrl();
                                } else {
                                    document.body.appendChild(
                                        <DynPopup showOkButton={true} size="dialog" title={Resources.Common.information}>
                                            {Resources.Common.elementCanNotOpen}
                                        </DynPopup>
                                    );
                                }
                            },
                            error: (err) => {
                                console.log(err);
                            }
                        });
                    } else {
                        this.redirectToRowClickUrl();

                    }
                });
            }
            else if (this.props.onRowClick) {
                this.element.addEventListener("click", this.props.onRowClick);
                this.element.classList.add("pointer");
            }
        }
        else {
            this.element.classList.add("pointer");
            this.element.addEventListener("click", () => {
                this.props.table.showEditPopup(this.props.editType, this.props.rowItem.model);
            });
        }
        return this.element;
    }

    private redirectToRowClickUrl = () => {
        var url = app.resolveUrl(this.props.rowClickUrl.replace("{id}", this.props.rowItem.modelId));
        url = url.replace("[additionalAction}", this.props.table.props.editAdditionalAction);

        if (this.props.table.props.rowClickUrlUsePopup) {

            const popup = new PagePopup({
                url: url,
                resultId: parseInt(this.props.rowItem.modelId),
                showCloseButton: false,
                fullScreen: true,
                onClose: (reason: PopupCloseType, id: number): boolean => {

                    if (this.props.table.props.loadUrl) {
                        // update all tables
                        for (let tableId in MsoTable.allTables) {
                            let table = MsoTable.allTables[tableId];
                            //if (table.props.editType == EditTypes.MeasureFullscreen || table.props.editType == EditTypes.MeasurePopup) {
                            if (reason == "delete") {
                                table.removeRow(id.toString());
                            }
                            else if (reason == "save") {
                                table.updateRow(id.toString());
                            }
                            //}

                            // TODO Bestimmen, ob die selbe Maßnahme in anderen Widgets auch aktualisiert werden muss.

                            //else {
                            //    // Recreate all widgets if exist
                            //    let frame = document.getElementById("widgetFrame");
                            //    if (frame) {
                            //        frame.innerHTML = "";
                            //        let controller = new WidgetController("widgetFrame", "cockpitWidgetsEdit", new WidgetContextFe());
                            //    }

                            //}
                        }
                    } else if (this.props.table.props.onCloseEditPopup) {
                        this.props.table.props.onCloseEditPopup(reason, id);
                    }

                    return true;
                }

            });
        } else {
            location.href = url;
        }
    }

    onDragStart = (ev: DragEvent) => {
        let elementOnMousePos = document.elementFromPoint(ev.clientX, ev.clientY);
        if (elementOnMousePos && elementOnMousePos.classList.contains("mt-drag-enable")) {
            ev.dataTransfer.effectAllowed = "move";
            app.dragData = {
                type: AppDragTypes.MsoTableRow,
                sourceObject: this
            };
            setTimeout(() => {
                this.hide();
            }, 0);
        }
        else {
            ev.preventDefault();
            ev.cancelBubble = true;
        }
    }

    onDragEnd = (ev: DragEvent) => {
        this.show();
    }

    onDragEnter = (ev: DragEvent) => {
        if (app.dragData && app.dragData.type == AppDragTypes.MsoTableRow) {
            this.dragCounter++;
            this.element.classList.add("mt-drop-animation");
            ev.stopPropagation();
        }
        else {
            ev.dataTransfer.dropEffect = "none";
        }
    }

    onDragLeave = (ev: DragEvent) => {
        if (app.dragData && app.dragData.type == AppDragTypes.MsoTableRow) {
            this.dragCounter--;
            if (this.dragCounter <= 0) {
                this.element.classList.remove("mt-drop-animation");
            }
            ev.stopPropagation();
        }
    }

    onDragOver = (ev: DragEvent) => {
        if (app.dragData && app.dragData.type == AppDragTypes.MsoTableRow) {
            ev.preventDefault();
            return false;
        }
    }

    onDrop = (ev: DragEvent) => {
        if (app.dragData && app.dragData.type == AppDragTypes.MsoTableRow) {
            this.element.classList.remove("mt-drop-animation");
            this.dragCounter = 0;
            ev.stopPropagation();
            let row = app.dragData.sourceObject as FlexContentRowComponent;
            row.insertBefore(this.element);
            this.props.flexTable.recalcPos();
        }
    }

    public setChildTable(childRow: HTMLElement, childTable: MsoTable) {
        this.childRow = childRow;
        this.childTable = childTable;
    }

    public collapse() {
        if (this.childRow) {
            this.childRow.classList.add("d-none");
            this.childRow.setAttribute("data-expanded", "false");
        }
    }

    public expand() {
        if (this.childRow) {
            this.childRow.classList.remove("d-none");
            this.childRow.setAttribute("data-expanded", "true");
        }
    }

    public show() {
        this.element.classList.remove("d-none");
        if (this.childRow && this.childRow.getAttribute("data-expanded") == "true") {
            this.childRow.classList.remove("d-none");
        }
    }

    public hide() {
        this.element.classList.add("d-none");
        if (this.childRow) {
            this.childRow.classList.add("d-none");
        }
    }

    public appendToContent() {
        this.element.parentElement.appendChild(this.element);
        if (this.childRow) {
            this.childRow.parentElement.appendChild(this.childRow);
        }
    }

    public remove() {
        this.element.parentElement.removeChild(this.element);
        if (this.childRow) {
            this.childRow.parentElement.removeChild(this.childRow);
        }
    }

    public updateRow(model: any) {
        this.props.rowItem.model = model;
        for (let column of this.props.columns.items) {
            this.cells[column.index] = column.updateCell(this.cells[column.index], model);
        }
    }

    public hideDeleteIcon() {
        let column = this.props.columns.findByType(TableColumnTypes.DeleteIcon);
        if (column) {
            column.hideContent(this.cells[column.index]);
        }
    }

    public insertBefore(insertElement: HTMLElement) {
        this.element.parentElement.insertBefore(this.element, insertElement);
        if (this.childRow) {
            this.childRow.parentElement.insertBefore(this.childRow, insertElement);
        }
    }
}
